<template>
  <div>
    <OrderSpecDeatilTable 
    :planOrderCode="planOrderCode"
     :disabled="disabled" />
  </div>
</template>
<script>
import OrderSpecDeatilTable from './components/table'
export default {
  components: { OrderSpecDeatilTable },
  props: {
    planOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
